/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CA,
    CAFromJSON,
    CAFromJSONTyped,
    CAToJSON,
} from './CA';

/**
 * 
 * @export
 * @interface TrustHolderDto
 */
export interface TrustHolderDto {
    /**
     * 
     * @type {string}
     * @memberof TrustHolderDto
     */
    trustHolderEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrustHolderDto
     */
    trustHolderName?: string;
    /**
     * 
     * @type {string}
     * @memberof TrustHolderDto
     */
    description?: string;
    /**
     * 
     * @type {Set<CA>}
     * @memberof TrustHolderDto
     */
    caList?: Set<CA>;
}

export function TrustHolderDtoFromJSON(json: any): TrustHolderDto {
    return TrustHolderDtoFromJSONTyped(json, false);
}

export function TrustHolderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrustHolderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trustHolderEntityId': !exists(json, 'trustHolderEntityId') ? undefined : json['trustHolderEntityId'],
        'trustHolderName': !exists(json, 'trustHolderName') ? undefined : json['trustHolderName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'caList': !exists(json, 'caList') ? undefined : (new Set((json['caList'] as Array<any>).map(CAFromJSON))),
    };
}

export function TrustHolderDtoToJSON(value?: TrustHolderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trustHolderEntityId': value.trustHolderEntityId,
        'trustHolderName': value.trustHolderName,
        'description': value.description,
        'caList': value.caList === undefined ? undefined : (Array.from(value.caList as Set<any>).map(CAToJSON)),
    };
}

